import { AdBreakType, AdBlockSize } from '../../../enums';
import { ChannelFormData } from '../../../pages/channelmanager/channels/channel-editor/ChannelFormData';
import { AdBreakTypeOption, adBreakTypeOptions } from './AdBreakTypeOptions';

export class AdsSponsorsForm {
  id: string = '';
  spotxId: string = '';
  initTime: number = 480; // 8 minutes
  loadTime: number = 360; // 6 minutes
  blockSize: AdBlockSize = AdBlockSize.AdPod;
  singleTime: number = 15;
  podTime: number = 30;
  overrideLive: boolean = true;
  liveAdMinTime: number = 150; // #357757 liveAdMinTime is not respected by streaming engine.
  liveAdMaxTime: number = 240; // 4 minutes
  primaryDomainUrl: string = '';
  adBreakType: AdBreakTypeOption | undefined = adBreakTypeOptions.find((o) => o.id === AdBreakType.BetweenContentOrAtAdCueMarker);
  adsPerHour: number = 8 * 60; // adsPerHour in seconds. Default = 8 * 60 for 8 minutes

  static createFromData(data: ChannelFormData) {
    const form = new AdsSponsorsForm();
    form.loadData(data);
    return form;
  }

  getAdBreakType(channel: Channel) {
    let found: any = null;
    if (channel && channel.metaData && channel.metaData.adConfiguration && channel.metaData.adConfiguration.adBreakType) {
      found = adBreakTypeOptions.find((o) => o.id === channel.metaData.adConfiguration.adBreakType);
    }
    return found ? found : adBreakTypeOptions.find((o) => o.id === AdBreakType.BetweenContentOrAtAdCueMarker);
  }

  loadData(data: ChannelFormData) {
    const { channel, assets } = data;

    const cfg = channel && channel.metaData ? channel.metaData.adConfiguration : null;
    if (cfg) {
      if (cfg.id) this.id = cfg.id;
      this.spotxId = cfg.spotxId;
      this.initTime = cfg.initTime;
      this.loadTime = cfg.loadTime;
      this.blockSize = cfg.blockSize;
      if (cfg.singleTime !== undefined && cfg.singleTime !== null) this.singleTime = cfg.singleTime;
      if (cfg.podTime !== undefined && cfg.podTime !== null) this.podTime = cfg.podTime;
      this.overrideLive = cfg.overrideLive;
      if (cfg.liveAdMinTime !== undefined && cfg.liveAdMinTime !== null) this.liveAdMinTime = cfg.liveAdMinTime;
      if (cfg.liveAdMaxTime !== undefined && cfg.liveAdMaxTime !== null) this.liveAdMaxTime = cfg.liveAdMaxTime;
      this.primaryDomainUrl = cfg.primaryDomainUrl;
      this.adBreakType = this.getAdBreakType(channel);
      if (cfg.adsPerHour != null) this.adsPerHour = cfg.adsPerHour;
    }
  }
}
